import RegisterForm from './pages/RegisterForm';
customElements.define('register-form', RegisterForm,{extends: 'form'});